export class LogContext {
  private readonly _context: string;

  constructor(context: string) {
    this._context = context;
  }

  get context(): string {
    return this._context;
  }
}

export interface LogMessage {
  context?: LogContext;
  severity?: 'error' | 'warn' | 'info';
  method: string;
  identifier: string;
  message: string;
  value?: any;
}
